import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const updateClientConfModalSelector = createSelector(modalsSelector, (modals) => modals.updateClientConf);

export default updateClientConfModalSelector;
